import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/kinetic-flux-logo-thumbnail.svg';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Kinetic Flux Logo" width="46" height="46" decoding="async" />
            <p>Full-stack product development &amp; cloud infrastructure.<br />Designed, built, shipped, and run end to end.</p>
          </div>
          <div className="footer-links">
            <h4>Site</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/work">Work</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Get in touch</h4>
            <p><FontAwesomeIcon icon={faEnvelope} /> info@kinetic-flux.com</p>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} Kinetic Flux. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
